import DashboardDiagnostico from '@/views/diagnostico/DashboardDiagnostico';
import AutoAvaliacaoComportamento from '@/views/diagnostico/comportamento/AutoAvaliacaoComportamento';
import AvaliacaoDeServidoresComportamento from '@/views/diagnostico/comportamento/AvaliacaoDeServidoresComportamento';
import AvaliacaoDeServidoresResponsabilidade
from '@/views/diagnostico/responsabilidade/AvaliacaoDeServidoresResponsabilidade';
import AutoAvaliacaoResponsabilidade from '@/views/diagnostico/responsabilidade/AutoAvaliacaoResponsabilidade';

const DiagnosticoRoutes = [
  {
    path: '/diagnostico',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Diagnóstico' },
      ],
      requiresAuth: true,
    },
    name: 'DashboardDiagnostico',
    component: DashboardDiagnostico,
  },
  {
    path: '/diagnostico/comportamento/autoavaliacao/',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Diagnóstico', href: '/diagnostico' },
        { position: 3, text: 'Autoavaliação Comportamental' },
      ],
      requiresAuth: true,
    },
    name: 'AutoAvaliacaoComportamento',
    component: AutoAvaliacaoComportamento,
  },
  {
    path: '/diagnostico/comportamento/chefia/',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Diagnóstico', href: '/diagnostico' },
        { position: 3, text: 'Avaliação Comportamental do Gestor Imediato' },

      ],
      requiresAuth: true,
    },
    name: 'AvaliacaoChefiaComportamento',
    component: AutoAvaliacaoComportamento,
  },
  {
    path: '/diagnostico/comportamento/servidores/',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Diagnóstico', href: '/diagnostico' },
        { position: 3, text: 'Avaliação Comportamental da Equipe' },
      ],
      requiresAuth: true,
    },
    name: 'AvaliacaoServidoresComportamento',
    component: AvaliacaoDeServidoresComportamento,
  },
  {
    path: '/diagnostico/comportamento/pares/',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Diagnóstico', href: '/diagnostico' },
        { position: 3, text: 'Avaliação Comportamental da Equipe' },
      ],
      requiresAuth: true,
    },
    name: 'AvaliacaoParesComportamento',
    component: AvaliacaoDeServidoresComportamento,
  },
  {
    path: '/diagnostico/responsabilidade/servidores/',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Diagnóstico', href: '/diagnostico' },
        { position: 3, text: 'Avaliação Técnica da Equipe' },
      ],
      requiresAuth: true,
    },
    name: 'AvaliacaoServidoresResponsabilidade',
    component: AvaliacaoDeServidoresResponsabilidade,
  },
  {
    path: '/diagnostico/responsabilidade/autoavaliacao/',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Diagnóstico', href: '/diagnostico' },
        { position: 3, text: 'Autoavaliação Técnica' },
      ],
      requiresAuth: true,
    },
    name: 'AutoAvaliacaoResponsabilidade',
    component: AutoAvaliacaoResponsabilidade,
  },
];

export default DiagnosticoRoutes;
